import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import organizationsState from './state';
const organizationsSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => organizationsState);
    },
    initialState: organizationsState,
    name: 'organizations',
    reducers: {
        errorReceiveOrganizations: state => {
            state.requestingOrganizations = false;
        },
        failedReceiveOrganizations: state => {
            state.requestingOrganizations = false;
        },
        optInKEX: {
            prepare: (organizationSlug, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        organizationSlug
                    }
                };
            },
            reducer: (state, action) => {
                const { consumerAPI, organizationSlug } = action.payload;
                if (consumerAPI) {
                    state.organization.enrolled_in_kex = true;
                    const orgIndex = state.organizations.findIndex(org => org.slug === organizationSlug);
                    state.organizations[orgIndex].enrolled_in_kex = true;
                }
                else {
                    state.organization.kex_participant = true;
                    const orgIndex = state.organizations.findIndex(org => org.slug === organizationSlug);
                    state.organizations[orgIndex].kex_participant = true;
                }
            }
        },
        optOutKEX: {
            prepare: (organizationSlug, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        organizationSlug
                    }
                };
            },
            reducer: (state, action) => {
                const { consumerAPI, organizationSlug } = action.payload;
                if (consumerAPI) {
                    state.organization.enrolled_in_kex = false;
                    const orgIndex = state.organizations.findIndex(org => org.slug === organizationSlug);
                    state.organizations[orgIndex].enrolled_in_kex = false;
                }
                else {
                    state.organization.kex_participant = false;
                    const orgIndex = state.organizations.findIndex(org => org.slug === organizationSlug);
                    state.organizations[orgIndex].kex_participant = false;
                }
            }
        },
        receiveOrganizations: {
            prepare: organizations => {
                return {
                    payload: {
                        organizations
                    }
                };
            },
            reducer: (state, action) => {
                const { organizations } = action.payload;
                state.organizations = organizations;
                state.requestingOrganizations = false;
            }
        },
        requestOrganizations: {
            prepare: (consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI
                    }
                };
            },
            reducer: state => {
                state.requestingOrganizations = true;
            }
        },
        resetOrganizations: () => organizationsState,
        setOrganization: {
            prepare: organization => {
                return {
                    payload: {
                        organization
                    }
                };
            },
            reducer: (state, action) => {
                const { organization } = action.payload;
                state.organization = organization;
            }
        }
    }
});
export const { errorReceiveOrganizations, failedReceiveOrganizations, optInKEX, optOutKEX, receiveOrganizations, requestOrganizations, resetOrganizations, setOrganization } = organizationsSlice.actions;
export default organizationsSlice.reducer;
